<template>
  <div class="gs_container">
    <div class="gs_crumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item
          ><span class="local">你的位置</span></el-breadcrumb-item
        >
        <el-breadcrumb-item>代付模块</el-breadcrumb-item>
        <el-breadcrumb-item>统计日报</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="search-box">
      <div class="item">
        起止时间：
      </div>
      <div class="item">
        <el-date-picker
          type="date"
          placeholder="开始时间"
          size="small"
          v-model="form.StartTime"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </div>
      <div class="item">
        <el-date-picker
          type="date"
          placeholder="结束时间"
          size="small"
          v-model="form.EndTime"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </div>
      <div class="item">
        商品ID：
      </div>
      <div class="item">
        <el-input
          size="small"
          suffix-icon="el-icon-arrow-down"
          v-model="form.Id"
        ></el-input>
      </div>
      <div class="item">
        <el-button type="danger" size="small" @click="search">查询</el-button>
        <el-button size="small" @click="reset">重置</el-button>
      </div>
    </div>
    <div class="tips"></div>
    <el-table
      ref="singleTable"
      :data="tableData"
      highlight-current-row
      border
      style="width: 100%"
    >
      <el-table-column type="index" width="50" align="center">
      </el-table-column>
      <el-table-column property="date" label="日期" align="center">
      </el-table-column>
      <el-table-column
        property="topSpeedWithdrawalCount"
        label="秒提笔数"
        align="center"
      >
      </el-table-column>
      <el-table-column
        property="topSpeedWithdrawalTotalAmount"
        label="秒提金额"
        align="center"
      >
      </el-table-column>
    </el-table>
    <div class="mgt15 mgb15 mgl15 mgr15" style="text-align: center;">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="form.total"
        :current-page="form.PageNumber"
        :page-size="form.PageSize"
        @current-change="changePage"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import mgr from '../../assets/js/securityapi';
import api from '../../assets/js/apiRequestHandler';
export default {
  data() {
    return {
      form: {
        Id: '',
        ApplicationUserId: '',
        StartTime: '',
        EndTime: '',
        PageNumber: 1,
        PageSize: 10,
        total: 0
      },
      tableData: []
    };
  },
  created() {
    this.getLists();
  },
  methods: {
    async getLists() {
      let header = await mgr();
      for (let i in this.form) {
        if (this.form[i] === '') {
          delete this.form[i];
        }
      }
      api
        .get('/api/Paid/StatisticalJournal', {
          headers: {
            Authorization: 'Bearer ' + header
          },
          params: this.form
        })
        .then(res => {
          if (res.status === 200) {
            this.form.total = JSON.parse(
              res.headers['x-pagination']
            ).TotalCount;
            this.tableData = res.data;
          }
        })
        .catch(err => {
          this.$messageError(err.message);
        });
    },
    search() {
      this.form.PageNumber = 1;
      this.getLists();
    },
    changePage(page) {
      console.log(page);
      this.form.PageNumber = page;
      this.getLists();
    },
    reset() {
      this.form = {
        Id: '',
        ApplicationUserId: '',
        StartTime: '',
        EndTime: '',
        PageNumber: 1,
        PageSize: 10,
        total: 0
      };
      this.tableData = [];
      this.getLists();
    }
  }
};
</script>

<style scoped>
.gs_container {
  background-color: #fff;
}

.search-box {
  display: flex;
  align-items: center;
  font-size: 14px;
  margin-top: 20px;
}

.search-box .item {
  margin-right: 10px;
}

.search-box .item.w1 {
  width: 120px;
}

.tips {
  font-size: 14px;
  margin-top: 15px;
  margin-bottom: 15px;
}

.pagination {
  text-align: center;
  margin: 20px 0;
}
</style>
